import { useEffect, useRef } from "react";

// Utils
import { isEmpty, isNullUndefined } from "@/main/services/utils";
import { SignalRExportInventoryResponse } from "@/main/models/common/signalRReceiveUpdatesResponse";
import { toast } from "react-toastify";
import { RoutesConstants } from "@/main/routes/routesConstants";
import colors from "@/main/style/colors";

interface HubItemExportInventoryProps {
	data: SignalRExportInventoryResponse[];
	customProps?: {
		onFinishedRequote: () => void;
		onErrorRequote: () => void;
	};
}

const HubItemExportInventory = ({ data }: HubItemExportInventoryProps) => {
	const formatteedData = isNullUndefined(data) ? [] : data;
	const lastFileGuid = useRef<string | null>(null);

	useEffect(() => {
		if (isNullUndefined(formatteedData)) return;
		const lastItemSignalR = formatteedData[formatteedData.length - 1];
		if (isNullUndefined(lastItemSignalR)) return;
		if (lastItemSignalR.isSuccess && !isEmpty(lastItemSignalR.fileName)) {
			if (lastItemSignalR.guidSupplierInventoryImport === lastFileGuid.current) return;
			lastFileGuid.current = lastItemSignalR.guidSupplierInventoryImport;
			const urlFilter = `#${RoutesConstants.inventorySearchImport}?tab=0&filename=${lastItemSignalR.fileName}`;
			toast.success(
				<div>
					{lastItemSignalR.message}
					<br />
					<span style={{ color: colors.pantone2727C, textDecoration: "underline" }}>{lastItemSignalR.fileName}</span>
				</div>,
				{
					autoClose: 15000,
					onClick: () => window.open(urlFilter, "_blank"),
				},
			);
		}
	}, [JSON.stringify(formatteedData)]);

	return <></>;
};

export default HubItemExportInventory;
